import { APP_NAMESPACE } from "./application";

export const RESULTS_PER_PAGE = `${APP_NAMESPACE}/RESULTS_PER_PAGE`;
